import { createWebHashHistory } from 'vue-router'
import { createRouter } from 'vue-router'

import Layout from '@/components/Layout'

import Login from '@/views/Login.vue'
import Dashboard from '@/views/Dashboard.vue'
import Home from '@/views/Home'
import AppList from '@/views/AppList/AppList'
import Decoration from '@/views/Decoration/Decoration'
const routes = [
    {
        path: '/',
        redirect: '/index'
    },
    //登录页面
    {
        path: '/login',
        component: Login
    },
    //主页面
    {
        path: '/index',
        component: Dashboard,
        redirect: '/welcome',
        meta: {
            title: '首页'
        },
        //应用管理
        children: [
            {
                path: '/welcome',
                component: Home,
                meta: {
                    title: '欢迎'
                }
            },
            {
                path: '/app',
                component: Layout,
                meta: {
                    title: '应用管理'
                },
                children: [
                    {
                        path: '/appList',
                        component: AppList,
                        meta: {
                            title: 'APP列表'
                        },
                    }
                ]
            }
        ]
    },
    //可视化编辑页面
    {
        path: '/visual/:id',
        component: Decoration,
        meta: {
            title: '可视化编辑'
        },
    }

]

const router = createRouter({
    routes,
    history: createWebHashHistory(),
})

//路由导航守卫
router.beforeEach((to, from, next) => {

    if (to.path.startsWith('/login')) {
        window.localStorage.setItem("token", '')
        window.localStorage.setItem("user", '')
        window.localStorage.setItem("menu", '')
        next()
    }
    else {
        let token = window.localStorage.getItem('token')
        if (token) {
            next()
        } else {
            next('/login')
        }
    }

    if (to.meta.title) { // 判断是否有标题
        document.title = to.meta.title;
    }
})

export default router

